// extracted by mini-css-extract-plugin
module.exports = {"jobsList":"Jobs_jobsList__1bO7W","allJobsButton":"Jobs_allJobsButton__31FVG","jobTitle":"Jobs_jobTitle__2d2HC"};